module.exports = __webpack_public_path__ + "img/ts_2009.de40bcb4.jpg";